import { render, staticRenderFns } from "./EditProductComponent.vue?vue&type=template&id=62ad944a"
import script from "./EditProductComponent.vue?vue&type=script&lang=js"
export * from "./EditProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports